<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-form @submit="onSubmit" autofocus greedy>
      <q-card-section class="no-padding">
        <q-banner class="bg-blue text-white" inline-actions>
          ثبت راننده جدید
          <template v-slot:action>
            <q-btn round icon="close" v-close-popup flat/>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section>
        <q-input
            autofocus
            class="q-mb-sm"
            v-model="localDriverInfo.Visitor_Name"
            filled
            hide-bottom-space
            :rules="[val => !!val || 'الزامی است']"
            label="نام و نام خانوادگی راننده"
        />
        <q-input
            :disable="disabled"
            dir="ltr"
            hide-bottom-space
            type="phone"
            class="q-mb-sm"
            v-model="localDriverInfo.Visitor_Tel"
            filled
            :rules="[val => !!val || 'الزامی است']"
            label="شماره تماس"
        />
        <q-input
            class="q-mb-sm"
            v-model="localDriverInfo.Visitor_NumCar"
            filled
            hide-bottom-space
            :rules="[val => !!val || 'الزامی است']"
            label="شماره پلاک ماشین"
        />
        <q-input
            class="q-mb-sm"
            v-model="localDriverInfo.VisitorCarType"
            filled
            hide-bottom-space
            :rules="[val => !!val || 'الزامی است']"
            label="نوع خودرو"
        />
        <q-input
            class="q-mb-sm"
            v-model="localDriverInfo.VisitorCarModel"
            filled
            hide-bottom-space
            :rules="[val => !!val || 'الزامی است']"
            label="مدل خودرو"
        />
      </q-card-section>
      <q-card-actions align="center">
        <q-btn label="تایید" type="submit" icon="check" color="primary"/>
        <q-btn label="انصراف" type="reset" icon="cancel" color="red" flat class="q-ml-sm" v-close-popup/>
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "DriverInfo",
  props: {
    driverInfo: {
      type: Object,
    }
  },
  data() {
    return {
      disabled:false,
      localDriverInfo: {
        Visitor_Name: '',
        Visitor_Tel: '',
        Visitor_NumCar: '',
        VisitorCarModel: undefined,
        VisitorCarType: undefined
      }
    }
  },
  methods: {
    ...mapActions({
      insert: 'Orders/addDriver'
    }),
    onSubmit() {
      this.insert(this.localDriverInfo).then((res) => {
        this.$emit('driver-added', res[0])
      })
    }
  },
  created() {
    if (this.driverInfo !== null) {
      this.localDriverInfo = this.driverInfo
      this.disabled = true
    }
  }
}
</script>

<style scoped>

</style>